import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { delay, filter, switchMap } from 'rxjs/operators';

import { GetAddressForEntityGQL, GetEntityById2, GetEntityById2GQL } from 'generated/graphql';

import { REFETCH_ENTITY_ADDRESS } from './address-refetch.actions';
import { isNilOrEmpty } from 'helpers';

@Injectable()
export class AddressRefetchEffects {

  refetchAddressAfterDelay$ = createEffect(
    () => this.actions$.pipe(
      ofType(REFETCH_ENTITY_ADDRESS),
      switchMap(({ payload }) => of(payload).pipe(
        delay(payload.delay ?? 3000),
      )),
      filter((payload) => !isNilOrEmpty(payload.entityId)),
      switchMap(payload => this.getEntityById.fetch(
        {
          campaignId: payload.campaignId,
          entityId: payload.entityId,
          withAddresses: true,
          withBestAddress: true
        },
        { fetchPolicy: 'network-only' }
      )
      ),
    ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private getEntityById: GetEntityById2GQL
  ) {
  }
}
